<template>
  <div class="card">
    <div class="card-body hm400">
      <div class="row">
        <div class="col-md-12">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                  class="nav-link active show"
                  id="team-announcements-tab"
                  data-toggle="tab"
                  href="#pending-tasks"
                  role="tab"
                  aria-controls="up"
              >Pending</a
              >
            </li>
            <li class="nav-item">
              <a
                  class="nav-link"
                  id="team-announcements-tab"
                  data-toggle="tab"
                  href="#active-tasks"
                  role="tab"
                  aria-controls="up"
              >Active</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content customer-table">
        <div id="pending-tasks" class="tab-pane active show">
          <PendingTask :getAllActiveTasks="getAllActiveTasks"/>
        </div>
        <div id="active-tasks" class="tab-pane">
          <div class="">
            <div class="" v-if="loading">
              <!-- Show the loader when async operation is going on -->
              <div class="loader"></div>
            </div>
            <perfect-scrollbar class="scroll-area-modal" v-else>
              <table class="table table-striped single-outage-table">
                <thead>
                <tr>
                  <th width="50%" class='text-left' scope="col">Task Name</th>
                  <th scope="col">Time elapsed</th>
                  <th class='text-center' scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="value in activeTaskList" :key="value.id">
                  <td width="50%">
                    <div class="d-flex align-items-center">
                      <div class='image-container pl-0 ml-0 mr-0'>
                        <img v-if="value.taskType==='sales Task' || value.taskType==='Manual sales Task'" width="70%"  src="../../../assets/img/sales.png" alt="Task Image">
                        <img v-else-if="value.taskType==='support Task' || value.taskType==='Manual support Task'" width="45%" src="../../../assets/img/support.svg" alt="Task Image">
                        <img v-else-if="value.taskType==='Migration Task'" width="50%"  src="../../../assets/img/migration.png" alt="Task Image">
                        <img v-else-if="value.taskType==='monitor'"  width="50%"  src="../../../assets/img/monitor.png" alt="Task Image">
                      </div>
                      <div class=""><span class="text-capitalize">{{ value.taskType }}</span> - {{domainAdjustmentForActiveTask(value.domain)}}</div></div>
                  </td>
                  <td class="text-left">{{ calculateTime(value.checkInTime)  }}</td>
                  <td class="text-center">
                    <button v-if="value.userUid" @click="goToNuxt(value.userUid)" title="Login as User" type="button" rel="tooltip" class="btn btn-outline-info btn-icon btn-sm mr-4">
                      <i class="fa fa-user"></i>
                    </button>
                    <button title="Resolve" type="button" rel="tooltip" class="btn btn-outline-success btn-icon btn-sm mr-4" v-if='resolvableTasks.includes(value.taskType)'  @click="resolveTask(value)">
                      <i class="fa fa-check"></i>
                    </button>
                    <button @click="openTicket(value.ticketId)" title="View ticket" type="button" rel="tooltip" class="btn btn-outline-danger btn-icon btn-sm" v-if='value.ticketId'>
                      <i class="fa fa-ticket"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </perfect-scrollbar >
            <div v-if="activeTaskList && activeTaskList.length === 0 && !loading">  <p class="hm300 card-text text-center text-danger mb-3 font-weight-bold">No data found.</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from "@/firebase/init";
import moment from "moment";
import swal from "sweetalert2";
import statisticsMixin from "@/mixins/statisticsMixin";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import TempLinks from "@/components/Admin/Tools/tempLinks.vue";
import PendingTask  from "@/components/Admin/AdminDashboard/PendingTask.vue";
export default {
  name: "ActiveTask",
  mixins: [statisticsMixin],
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  components: {
    TempLinks,
    PerfectScrollbar,
    PendingTask
  },
  data () {
    return {
      activeTaskList: [],
      loading: true,
      resolvableTasks: ['sales Task', 'support Task', 'Manual sales Task', 'Manual support Task']
    }
  },
  methods: {
    goToNuxt (docId) {
      if(docId) {
        window.open(`https://wpo.bigscoots.com/user/dashboard?id=${docId}`,'WPO-Bigscoots');
      }
    },
    openTicket(ticketNo) {
      window.open(`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&num=${ticketNo}`, '_blank')
    },
    async resolveManualTask(task){
      this.loading= true;
      try {
        await db.collection('manualTasks')
            .doc(task.taskId)
            .update({ resolvedBy: `${this.user.firstName} ${this.user.lastName}`, resolvedAt:  new Date().toISOString() , resolved: true } );
        try {
          const taskRef = await db.collection('manualTasks').doc(task.taskId).get();
          await this.$http.post('/utilities/update_manual_task_to_slack', {
            grant_type: 'token',
            ...taskRef.data(),
            resolvedBy: `${this.user.firstName} ${this.user.lastName}`,
            actionType: 'resolve'
          });
        }catch (e) {
          console.log(e.toString())
        }

        try{
          await this.incrementCountBasedOnType(this.user, 'support')
          console.log('this task', task)
          await this.addRecentActivity({
            type  : 'info',
            actionType: task.taskType,
            message: `${task.type} for domain ${this.domainAdjustment(task.domain)} has been resolved by ${this.user.firstName} ${this.user.lastName}.`,
            customer: {
              email: task.hostBillID ? task.hostBillID : null,
              domain: task.domain ,
            }
          })
        }catch (e) {
          console.log('line 512', e.toString())
        }
      } catch (e) {
        console.log(e.toString())
      }
    },
    async unPauseServer (data) {
      try {
        await this.$http.post('/utilities/resume-server', {
          grant_type: 'token',
          ip: data.ip,
          hbDocId: data.hbDocId
        })
      } catch (e) {
        await this.addLog({
          message: `Error in resuming server to check disk space again IP: ${data.ip}`,
          level: "error"
        })
        console.log(e.toString())
      }
    },
    async resolveHostBillTask (task) {
      this.loading = true;
      let errorInResolving = false;
      if(task.text === 'New Domain Added' && task.taskType === 'support Task') {
        // set ticket status to answered
        try {
          if (task.ticketId) {
            await this.$http.post('/host-bill/update-ticket-status', {
              grant_type: 'token',
              status: 'Answered',
              ticketNumber: task.ticketID
            })
          }
        } catch (e) {
          console.log('Something went wrong while setting status of ticket to answered')
        }
        let ref = await db.collection('jobLogs')
            .where('inputDomain', '==', task.domain)
            .where('jobName', '==', 'domain-create')
            .where('status', 'in', ['Pending', 'running', 'paused']).get();
        if (ref.size) {
          this.loading = false;
          swal('Please wait!', 'Create domain job is running for this domain yet.', 'error');
          return true
        }
        console.log('Mark HB Ticket as low / Reply to HB Ticket / make domain active / status cake active');
        console.log(task);
        await this.$http.post('/domain/resolve-support-task', {
          grant_type: 'token',
          domain: task.domain,
          email: task.email,
          ticketNumber: task.ticketId
        }).catch(e => {
          console.error(e);
          errorInResolving = true;
          let self=this
          let buttonHtml = '<div>' +
              `<div>${e.response.data.msg}</div>` +
              '<br/>' +
              '<ul class="list-inline">' +
              '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Resolve</button></li>' +
              '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Delete</button></li>' +
              '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
              '</ul></div>';
          swal({
            title: "Error",
            html: buttonHtml,
            type: 'question',
            showCancelButton: false,
            showConfirmButton: false,
            onOpen: function () {
              console.log('On Opne');
              /* eslint-disable */
              $('.sw_butt1').on('click',async function () {
                await db.collection('bigScootsTasks').doc(task.docId).update({
                  status: 'resolved',
                  resolvedAt: new Date().toISOString(),
                  resolvedBy: self.user.firstName + ' ' + self.user.lastName
                });
                const email = task.email ? task.email : null;
                const domain = task.domain ? task.domain : null;
                const message = domain !== null ?
                    `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                    :
                    `${task.type === 'sales' ? 'Sales' : 'Support'} task has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                await self.addRecentActivity({
                  type  : 'info',
                  actionType: `${task.type} Task`,
                  message: message,
                  customer: {
                    email: email,
                    domain: task.domain
                  }
                })
                swal.close();
              });
              $('.sw_butt2').on('click',async function () {
                await db.collection('bigScootsTasks').doc(task.taskId).delete()
                swal.close();
              });
              $('.sw_butt3').on('click',function () {
                console.log('close');
                swal.close();
              });
              /* eslint-enable */
            }
          });
          // swal('Error!', e.response.data.msg, 'error');
        })
      }
      else if (task.text === 'New Staging Domain Added' && task.taskType === 'support Task' && task.ticketId) {
        await this.$http.post('/host-bill/update-ticket-status', {
          grant_type: 'token',
          domain: task.domain,
          email: task.email,
          ticketNumber: task.ticketId,
          status: 'Answered'
        }).catch(e => {
          console.error(e);
          errorInResolving = true;
          let self=this
          let buttonHtml = '<div>' +
              '<div>{{e.response.data.msg}}</div>' +
              '<br/>' +
              '<ul class="list-inline">' +
              '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Resolve</button></li>' +
              '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Delete</button></li>' +
              '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
              '</ul></div>';
          swal({
            title: "Error",
            html: buttonHtml,
            type: 'question',
            showCancelButton: false,
            showConfirmButton: false,
            onOpen: function () {
              console.log('On Opne');
              /* eslint-disable */
              $('.sw_butt1').on('click',async function () {
                await db.collection('bigScootsTasks').doc(task.taskId).update({
                  status: 'resolved',
                  resolvedAt: new Date().toISOString(),
                  resolvedBy: self.user.firstName + ' ' + self.user.lastName
                });
                const email = task.email ? task.email : null;
                const domain = task.domain ? task.domain : null;
                const message = domain !== null ?
                    `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                    :
                    `${task.type === 'sales' ? 'Sales' : 'Support'} task has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                await self.addRecentActivity({
                  type  : 'info',
                  actionType: `${task.type} Task`,
                  message: message,
                  customer: {
                    email: email,
                    domain: task.domain
                  }
                })
                swal.close();

              });
              $('.sw_butt2').on('click',async function () {
                await db.collection('bigScootsTasks').doc(task.docId).delete()
                swal.close();
              });
              $('.sw_butt3').on('click',function () {
                console.log('close');
                swal.close();
              });
              /* eslint-enable */
            }
          });
          // swal('Error!', e.response.data.msg, 'error');
        })
      }
      if(!errorInResolving) {
        if (task.unPauseServer) {
          // unpause server
          await this.unPauseServer(task);
        }
        await db.collection('bigScootsTasks').doc(task.taskId).update({
          status: 'resolved',
          resolvedAt: new Date().toISOString(),
          resolvedBy: this.user.firstName + ' ' + this.user.lastName
        });
        const email = task.email ? task.email : null;
        const domain = task.domain ? task.domain : null;
        const message = domain !== null ?
            `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${this.user.firstName} ${this.user.lastName}.`
            :
            `${task.type === 'sales' ? 'Sales' : 'Support'} task has been resolved by ${this.user.firstName} ${this.user.lastName}.`
        const data= {
          type  : 'info',
          actionType: `${task.type} Task`,
          message: message,
          customer: {
            email: email,
            domain: task.domain
          }};
        await this.addRecentActivity({...data})
      } else {
        await this.addLog({
          primaryPlan: 'Account Based Operation',
          message: `User has resolved a support task for Domain: ${task.domain}, Type: ${task.text} `,
          level: "info"
        })
      }
      try{
        await this.incrementCountBasedOnType(this.user, 'support')
      }catch (e) {
        console.log('line 392', e.toString())
      }

    },
    async resolveTask(task){
      try{
        if(task.taskType==='Manual sales Task' || task.taskType==='Manual support Task'){
          await this.resolveManualTask(task)
          await this.removeAdminActiveTask(task);
        }
        else{
          await this.resolveHostBillTask(task);
          await this.removeAdminActiveTask(task);
        }
      }
      catch(e){
        console.log(e.toString() , 'Error in resolving task from dashboard');
      }
      finally {
        this.activeTaskList=this.activeTaskList.filter((value)=>value.taskId !== task.taskId)
        this.loading=false;
      }

    },
    domainAdjustmentForActiveTask(value){
      if(value){
        return value.length > 40 ? `${value.slice(0,40)}...` : value
      }
    },
    calculateTime(timestamp){
      return moment(timestamp).fromNow()
      // const currentDateTime = new Date();
      // const parsedTimestamp = new Date(timestamp);
      // const elapsedMilliseconds = currentDateTime - parsedTimestamp;
      // const elapsedMinutes = Math.floor(elapsedMilliseconds / (1000 * 60));
      // return elapsedMinutes;
    },
    async getAllActiveTasks(){
      this.activeTaskList=[];
      this.loading=true;
      try{
        const ref = await db.collection('activeTasks').where('userUid', '==', this.user.uid).orderBy('createdAt', 'desc').limit(20).get();
        if (ref.size) {
          ref.forEach(el => {
            this.activeTaskList.push({id: el.id, ...el.data()})
          })
          this.activeTaskList = this.activeTaskList.filter(el => el.taskType !== 'monitor')
        }
      }
      catch(e){
        console.log(e, 'Error in fetching active tasks')
      }
      finally {
        this.loading= false;
      }
    },
  },
  mounted() {
  this.getAllActiveTasks()
  }
}

</script>
<style scoped>

.image-container {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Style the image inside the container */
.image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  mix-blend-mode: multiply;
}
.scroll-area-modal {
  position: relative;
  max-height: 350px;
  overflow: hidden;
}

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  hr {
    border-top: 1px solid rgba(255,255,255,.5);
  }
}
table{
  tr {
    .task-width {
      width:70%;
    }
    td {
      /deep/  p {
        margin: 0 !important;
      }
    }
  }
}
hr {
  &.h-3 {
    border-top: 3px solid rgba(0,0,0,.1);
  }
}
.pagination{
  display: inline-flex !important;
}
.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;
    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
    &.default {
      color: currentColor;
    }
    &:hover{
      background-color:transparent !important;
      color: currentColor !important;
    }
  }
}
.cpy-btn{
  margin: 0;
}
.fs-10{
  font-size: 10px;
}
.h-43{
  height:43px;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
  &:hover{
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }
  .collapse-btn{
    margin-top: 0.5rem !important;
  }
  .domain-head{
    display: flex;
    justify-content: space-between;
    .h5-m0 {
      margin: 0;
    }
    .ul-m0{
      margin: 0;
    }
  }
  .domain-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .badge{
      text-transform: none !important;
    }
  }
}
.bl-bt{
  display: flex;
  align-items: flex-end;
  button {
    margin: 0 !important;
  }
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
th{
  font-weight: bold !important;
}
</style>
